import { motion } from "framer-motion"
import { Navbar } from "../shared/components/Navbar"
import { useLanguage } from "../shared/context/LanguageContext"

const InTheNews = () => {
    const { translation } = useLanguage()

    const gridVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.08,
            },
        },
    }

    const cardVariants = {
        hidden: { opacity: 0, y: 16 },
        show: { opacity: 1, y: 0, transition: { duration: 0.35 } },
    }

    return (
        <main>
            <div className="sticky top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] bg-secondary rounded-3xl">
                <Navbar />
            </div>
            <div className="flex flex-col gap-5 px-5 md:gap-9 md:py-9 md:px-9 lg:gap-10 lg:py-0 lg:pt-[4.375rem] lg:px-[5.625rem]">
                <div className="flex flex-col gap-4 lg:gap-2.5 min-w-[21rem] text-[1.75rem] md:text-3xl lg:text-[2.5rem] font-bold px-5 pt-9 lg:px-0 lg:pt-0">
                    <div className="text-primary">{translation.inTheNews}</div>
                    <div className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black">{translation.inTheNewsDesc}</div>
                </div>
                <motion.div
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-[1.875rem] px-5 lg:px-0 pb-[1.875rem] lg:pb-0"
                    variants={gridVariants}
                    initial="hidden"
                    animate="show"
                >
                    {translation.news.map((news, index) => (
                        <motion.div
                            key={index}
                            className="relative w-auto h-auto rounded-[1.25rem] border border-[#C9E1E2] hover:cursor-pointer"
                            onClick={() => window.open(news.newsLink, "_blank")}
                            variants={cardVariants}
                            whileHover={{ y: -6, boxShadow: "0px 8px 20px rgba(0, 78, 100, 0.15)" }}
                            whileTap={{ scale: 0.99 }}
                            transition={{ duration: 0.2, ease: "easeOut" }}
                        >
                            <div className="absolute top-4 start-4 py-2 px-2.5 bg-secondary rounded-[0.5rem] text-xs font-bold text-[#095B72]">
                                {news.media}
                            </div>
                            <img src={news.newsImage} alt={news.newsTitle} className="w-full h-[18.75rem] lg:h-52 object-cover rounded-t-[1.25rem]" />
                            <div className="flex flex-col gap-4 p-5">
                                <div className="text-base font-normal text-[#979797]">{news.newsDate}</div>
                                <div className="flex flex-col gap-1">
                                    <div className="text-[1.375rem] font-bold text-primary">{news.newsTitle}</div>
                                    <div className="text-xl font-normal text-blackTwo">{news.newsDescription}</div>
                                </div>
                                <div className="text-base font-bold text-softGreen hover:text-[#66B57C] cursor-pointer" onClick={() => window.open(news.newsLink, "_blank")}>{translation.readArticle}</div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </main>
    )
}

export default InTheNews